export default "__VITE_ASSET__65dc0d42__"